"use strict";
// Hopefully temporary separate file for when simple answer to sharing types without having dependency errors appears by magic
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrDataQueryOutputReducer = exports.summariseDatastoreObjectKeys = exports.isGetGraphTraversalRequest = exports.isValidEdgeTraversalPath = exports.isEdgeParams = exports.ValidObjectDeduper = exports.isVOBArrayOfSameType = exports.isVOBofType = exports.isValidBusinessObject = exports.isDatastoreObjectType = exports.getZombieEdge = exports.getPredictableZombies = exports.getPredictableZombie = exports.getZombieInstanceFromDatastoreObject = exports.getZombieInstance = exports.getZombieInstanceFromPrimaryKey = exports.identitiesMatch = exports.isEdgeForNode = exports.stripNode = exports.stripEdge = exports.isPseudoAttribute = exports.isNakedEdge = exports.isMalformedNode = exports.isNode = exports.isEdge = exports.isDatastoreObject = exports.isDatastoreKey = exports.getCardinality = exports.CardinalityMap = exports.Cardinality = exports.TraversalToAdjacentType = exports.Traversal = exports.hasS3Metadata = exports.hasMetadata = exports.QueryTypes = exports.PSEUDO_ATTRIBUTE_TYPEIDS = exports.FilterTypes = exports.ConditionTypes = exports.PathDirection = void 0;
const common_1 = require("./common");
const graphQueryTypes_1 = require("./graphQueryTypes");
var PathDirection;
(function (PathDirection) {
    PathDirection["parent"] = "PARENT";
    PathDirection["child"] = "CHILD";
})(PathDirection || (exports.PathDirection = PathDirection = {}));
var ConditionTypes;
(function (ConditionTypes) {
    ConditionTypes["between"] = "BETWEEN";
    ConditionTypes["beginsWIth"] = "BEGINS_WITH";
    ConditionTypes["contains"] = "CONTAINS";
    ConditionTypes["equals"] = "=";
    ConditionTypes["notEquals"] = "<>";
    ConditionTypes["and"] = "and";
})(ConditionTypes || (exports.ConditionTypes = ConditionTypes = {}));
var FilterTypes;
(function (FilterTypes) {
    FilterTypes["simpleAnd"] = "SIMPLE_AND";
})(FilterTypes || (exports.FilterTypes = FilterTypes = {}));
exports.PSEUDO_ATTRIBUTE_TYPEIDS = [
    'DeviceConfig',
    'DeviceHistory',
    'DeviceControlTransaction',
    'GatewayConfig',
    'Incident',
    'ObjectHistory',
    'ObservationHistory',
    'ThingShadowState',
];
var QueryTypes;
(function (QueryTypes) {
    QueryTypes["simplePath"] = "SIMPLE_PATH";
    QueryTypes["directedPath"] = "DIRECTED_PATH";
    QueryTypes["filteredGet"] = "FILTERED_GET";
    QueryTypes["searchByType"] = "SEARCH_BY_TYPE";
    QueryTypes["LIST_LIMITED_ALL_TYPES"] = "LIST_LIMITED_ALL_TYPES";
})(QueryTypes || (exports.QueryTypes = QueryTypes = {}));
const hasMetadata = (x) => !!x && typeof x.metadata === 'object';
exports.hasMetadata = hasMetadata;
const hasS3Metadata = (x) => (0, exports.hasMetadata)(x) && x.metadata.s3?.bucketIdentifier && x.metadata.s3?.key;
exports.hasS3Metadata = hasS3Metadata;
/** Direction of Graph Traversal in the canonical sense of the datatmodel as defined in the EdgeTypeMatrix */
var Traversal;
(function (Traversal) {
    Traversal["ASCENDING"] = "ASCENDING";
    Traversal["DESCENDING"] = "DESCENDING";
})(Traversal || (exports.Traversal = Traversal = {}));
exports.TraversalToAdjacentType = {
    [Traversal.ASCENDING]: common_1.AdjacentType.PARENT,
    [Traversal.DESCENDING]: common_1.AdjacentType.CHILD,
};
/** contraint of edgeType */
var Cardinality;
(function (Cardinality) {
    Cardinality["NONE"] = "NONE";
    Cardinality["ONE"] = "ONE";
    Cardinality["MANY"] = "MANY";
})(Cardinality || (exports.Cardinality = Cardinality = {}));
exports.CardinalityMap = {
    NONE: 0,
    ONE: 1,
    MANY: null,
};
const getCardinality = (cardinalityNumber) => {
    let cardinality = Cardinality.NONE;
    if (cardinalityNumber === null) {
        cardinality = Cardinality.MANY;
    }
    else if (cardinalityNumber === 0) {
        cardinality = Cardinality.NONE;
    }
    else if (cardinalityNumber === 1) {
        cardinality = Cardinality.ONE;
    }
    else if (cardinalityNumber > 1) {
        cardinality = Cardinality.MANY;
    }
    return cardinality;
};
exports.getCardinality = getCardinality;
const isDatastoreKey = (ob) => {
    let isKey = false;
    if (typeof ob === 'string') {
        const parts = ob.split(':');
        const partsValid = parts.every((p) => {
            const valid = /^[a-zA-Z0-9:_-]+$/.test(p);
            return valid;
        });
        isKey = parts.length > 1 && /^[a-zA-Z_]+$/.test(parts[0]) && partsValid;
    }
    return isKey;
};
exports.isDatastoreKey = isDatastoreKey;
const isDatastoreObject = (item) => !!item && (0, exports.isDatastoreKey)(item.sk) && (0, exports.isDatastoreKey)(item.pk);
exports.isDatastoreObject = isDatastoreObject;
const isEdge = (item) => (0, exports.isDatastoreObject)(item) && item.sk !== item.pk;
exports.isEdge = isEdge;
const isNode = (item) => (0, exports.isDatastoreObject)(item) && item.sk === item.pk && !item.edgeTypeId;
exports.isNode = isNode;
// where data has been leaked from edges onto nodes. Used where such bad data would throw part of a long iterative process and its deemed acceptable
const isMalformedNode = (item) => (0, exports.isDatastoreObject)(item) && item.sk === item.pk && !!item.edgeTypeId;
exports.isMalformedNode = isMalformedNode;
const isNakedEdge = (item) => {
    let isNaked = false;
    const validKeys = ['type', 'id', 'pk', 'sk', 'name'];
    isNaked = (0, exports.isEdge)(item) && Object.keys(item).every((itemKey) => validKeys.includes(itemKey));
    return isNaked;
};
exports.isNakedEdge = isNakedEdge;
const isPseudoAttribute = (vob) => (0, exports.isDatastoreKey)(vob.pk) && exports.PSEUDO_ATTRIBUTE_TYPEIDS.includes(vob.type);
exports.isPseudoAttribute = isPseudoAttribute;
/** removes all non edge attributes. Be careful when using getObjectHash to compare for changes as ttl is added as undefined and will change hash of a raw edge from dynamodb */
const stripEdge = (item) => (({ sk, pk, id, type, ttl, name, edgeTypeId, edgeAttributes }) => ({ sk, pk, id, type, ttl, name, edgeTypeId, edgeAttributes }))(item);
exports.stripEdge = stripEdge;
/** returns base ValidObjectType keys plus any defined in preservedKeys */
const stripNode = (item, presevedKeys) => {
    const datastoreObject = (({ sk, pk, id, type, name }) => ({ sk, pk, id, type, name }))(item);
    const others = presevedKeys ? Object.fromEntries(presevedKeys.map((k) => [k, item[k]])) : {};
    Object.assign(datastoreObject, others);
    return datastoreObject;
};
exports.stripNode = stripNode;
const isEdgeForNode = (edge, node) => {
    let isEdgeForNode = (0, exports.isEdge)(edge) && (0, exports.isNode)(node);
    const matchedByPk = edge.pk === node.sk;
    const matchedBySk = edge.sk === node.sk;
    isEdgeForNode = isEdgeForNode && (matchedByPk || matchedBySk);
    return isEdgeForNode;
};
exports.isEdgeForNode = isEdgeForNode;
/** matches objects on pk and sk */
const identitiesMatch = (a, b) => (0, exports.isDatastoreObjectType)(a) && (0, exports.isDatastoreObjectType)(b) && a.sk == b.sk && a.pk == b.pk;
exports.identitiesMatch = identitiesMatch;
const getZombieInstanceFromPrimaryKey = (pk, others) => {
    const [type, ...idOthers] = pk.split(':');
    const id = idOthers.join(':');
    const zombieInstance = { type, id, sk: `${type}:${id}`, pk: `${type}:${id}` };
    return { ...zombieInstance, ...others };
};
exports.getZombieInstanceFromPrimaryKey = getZombieInstanceFromPrimaryKey;
/** returns ValidModelObject<T>
 * Ignores any provided sk or pk in favor of creating keys from type and id.
 * This is the preferred way to directly construct a zombie with known type
 */
const getZombieInstance = (item) => {
    const { type, id, ...others } = item;
    const key = `${type}:${id}`;
    const zombieInstance = { type, id, sk: key, pk: key, ...others };
    return zombieInstance;
};
exports.getZombieInstance = getZombieInstance;
const getZombieInstanceFromDatastoreObject = (dob) => (0, exports.getZombieInstanceFromPrimaryKey)(dob.sk, dob);
exports.getZombieInstanceFromDatastoreObject = getZombieInstanceFromDatastoreObject;
const getPredictableZombie = (type, id = 0, others) => {
    const UUIDCompliant = `00000000-0000-5000-A000-${id.toString().padStart(12, '0')}`;
    const sk = `${type}:${UUIDCompliant}`;
    return (0, exports.getZombieInstanceFromPrimaryKey)(sk, { name: `${type} ${UUIDCompliant}`, id: UUIDCompliant, ...others });
};
exports.getPredictableZombie = getPredictableZombie;
const getPredictableZombies = (type, numberOfZombies, others) => {
    let zombies = [];
    for (let i = 0; i < numberOfZombies; i++) {
        zombies.push((0, exports.getPredictableZombie)(type, i, others));
    }
    return zombies;
};
exports.getPredictableZombies = getPredictableZombies;
const getZombieEdge = (source, target, edgeTypeId, edgeAttributes) => {
    const edge = (0, exports.stripEdge)({ ...target, pk: source.pk, edgeTypeId });
    edge.edgeAttributes = edgeAttributes;
    if (edge.ttl === undefined) {
        delete edge.ttl;
    }
    return edge;
};
exports.getZombieEdge = getZombieEdge;
const isDatastoreObjectType = (x) => {
    const c = x;
    return typeof c.pk === 'string' && typeof c.sk === 'string';
};
exports.isDatastoreObjectType = isDatastoreObjectType;
const isValidBusinessObject = (item) => {
    if (!item)
        return false;
    const possible = item;
    return possible.type !== undefined && possible.id !== undefined && possible.sk !== undefined && possible.pk !== undefined;
};
exports.isValidBusinessObject = isValidBusinessObject;
const isVOBofType = (type, item) => {
    if (!item)
        return false;
    const possible = item;
    return possible.type === type && (0, exports.isValidBusinessObject)(item);
};
exports.isVOBofType = isVOBofType;
const isVOBArrayOfSameType = (arr) => {
    return (arr.every(exports.isValidBusinessObject) &&
        arr.reduce((a, c, i, arr) => {
            const next = arr[i + 1];
            if (next) {
                a = c.type === next.type;
            }
            return a;
        }, true));
};
exports.isVOBArrayOfSameType = isVOBArrayOfSameType;
/** produces unique array where array input may have dups, use repalceMatches where dups may have been pushed onto array and they should overwrite existings */
const ValidObjectDeduper = (obs, replaceMatches) => obs.reduce((a, c) => {
    const existsIdx = a.findIndex((ai) => (0, exports.identitiesMatch)(ai, c));
    if (existsIdx === -1) {
        a.push(c);
    }
    else if (replaceMatches === true) {
        a.splice(existsIdx, 1, c);
    }
    return a;
}, []);
exports.ValidObjectDeduper = ValidObjectDeduper;
const isEdgeParams = (x) => {
    const y = x;
    const hasObjectType = !!y.objectTypeId;
    const mayHaveAdjacencyType = !y.adjacencyType || [common_1.AdjacentType.CHILD, common_1.AdjacentType.PARENT, common_1.AdjacentType.SUBJECT].includes(y.adjacencyType);
    const mayHaveEdgeTypeId = !y.edgeTypeId || typeof y.edgeTypeId === 'string';
    const mayHaveNodeFilters = !y.nodeFilters || y.nodeFilters.every(graphQueryTypes_1.isFilterGroup);
    return hasObjectType && mayHaveAdjacencyType && mayHaveEdgeTypeId && mayHaveNodeFilters;
};
exports.isEdgeParams = isEdgeParams;
const isValidEdgeTraversalPath = (item) => item instanceof Array && item.every(exports.isEdgeParams);
exports.isValidEdgeTraversalPath = isValidEdgeTraversalPath;
const isGetGraphTraversalRequest = (request) => {
    const { contextObjects, path } = request;
    return (0, exports.isValidEdgeTraversalPath)(path) && contextObjects.every(exports.isDatastoreObject);
};
exports.isGetGraphTraversalRequest = isGetGraphTraversalRequest;
/** output short pk to sk version of object as string, for development */
const summariseDatastoreObjectKeys = (ob) => `${ob?.pk} > ${ob?.sk}`;
exports.summariseDatastoreObjectKeys = summariseDatastoreObjectKeys;
const queryDataMerge = (existingQueryOutput, nextQueryOutput) => {
    if (nextQueryOutput) {
        if (!existingQueryOutput) {
            existingQueryOutput = {};
        }
        if (nextQueryOutput.Items) {
            existingQueryOutput.Items = existingQueryOutput.Items ? [...existingQueryOutput.Items, ...nextQueryOutput.Items] : nextQueryOutput.Items;
        }
        if (nextQueryOutput.Count) {
            existingQueryOutput.Count = existingQueryOutput.Count ? existingQueryOutput.Count + nextQueryOutput.Count : nextQueryOutput.Count;
        }
        if (nextQueryOutput.LastEvaluatedKey) {
            existingQueryOutput = nextQueryOutput.LastEvaluatedKey;
        }
    }
    return existingQueryOutput;
};
/** aggregates the ErrData output of an array of queries */
const ErrDataQueryOutputReducer = (results) => results.reduce((acc, curr) => {
    const mutant = {
        err: curr.err ? (acc.err ? new Error(acc.err.message + '\n' + curr.err?.message) : new Error(curr.err?.message)) : acc.err,
        data: queryDataMerge(acc.data, curr.data),
    };
    return mutant;
}, { err: null, data: null });
exports.ErrDataQueryOutputReducer = ErrDataQueryOutputReducer;
